const getDefaultState = () => {
  return {
    helpCenter: false,
    miniGuidelines: false,
    rematching: false,
    blocking: false,
    excluding: false,
    blockingComplete: false,
    excludingComplete: false,
    unexcludingComplete: false,

    reportModal: false,
  };
};

const state = getDefaultState();

// Synchronous
const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  SET_MODAL_STATE(state, modalData) {
    state[modalData.modal] = modalData.newState;
  },

  TOGGLE_STATE(state, modal) {
    state[modal] = !state[modal];
  },
};

// Asynchronous
const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },

  setModalState({ commit }, modalData) {
    commit("SET_MODAL_STATE", modalData);
  },

  toggleState({ commit }, modal) {
    commit("TOGGLE_STATE", modal);
  },
};

const modals = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default modals;
